import { messages as fr } from './locales/locale-fr.js'
import { messages as en } from './locales/locale-en.js'
import * as i18n from 'i18next'

export const currentLanguage: 'fr' | 'en' | 'es' | 'de' | 'pr' = 'en';

i18n
  .init({
    interpolation: {
      // React already does escaping
      escapeValue: false,
    },
    lng: currentLanguage, // 'en' | 'es'
    // Using simple hardcoded resources for simple example
    resources: {
      fr: {
        translation: fr
      },
      en: {
        translation: en
      },
    },
  })

export default i18n


// WEBPACK FOOTER //
// ./src/assets/messages/index.ts